import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Row = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: theme.spacing.small,
}));

export const HCell = styled.div(() => ({
    display: "flex",
    alignItems: "flex-start",
}));

export const Label = styled(Text)(({ theme }) => ({
    background: "linear-gradient(90deg, #edfff8 0%, rgba(237, 255, 248, 0) 143.13%)",
    borderRadius: theme.cornerRadius.large,
    padding: theme.spacing.xxSmall,
    marginLeft: theme.spacing.xSmall,
}));
